// tells if the Oldtime has elapsed 59 minutes - (59 * 60 * 1000)
// returns true if checkTime has nearly expired
// return false if checkTime has not nearly expired

export default checkTime => {
  return !((new Date().getTime() - checkTime) / (59 * 60 * 1000) < 1)
}
